import { mapActions } from 'vuex'

export const impersonatingMixin = {
  methods: {
    ...mapActions({
      deleteImpersonate: 'authStore/deleteImpersonate',
    }),
    async deleteHandler() {
      // ローカルストレージのなりすまし部署IDを削除しておく
      // delete record in DB
      const result = await this.deleteImpersonate()
      if (result) {
        window.localStorage.removeItem('impersonated_division_id')
      }
    },
  },
}
